const API_BASE = process.env.REACT_APP_API_URL || '/api';

function getAuthHeaders() {
  const token = sessionStorage.getItem('va_token');
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export async function requestOtp(email) {
  const res = await fetch(`${API_BASE}/auth/request-otp`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email }),
  });
  return res.json();
}

export async function verifyOtp(email, code) {
  const res = await fetch(`${API_BASE}/auth/verify-otp`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, code }),
  });
  const data = await res.json();
  if (data.token) {
    sessionStorage.setItem('va_token', data.token);
    sessionStorage.setItem('va_session', JSON.stringify(data));
  }
  return data;
}

export async function getScenarios() {
  const res = await fetch(`${API_BASE}/scenarios`, {
    headers: getAuthHeaders(),
  });
  return res.json();
}

function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const base64 = reader.result.split(',')[1];
      resolve(base64);
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

export async function submitSoapNote(scenarioId, scenarioName, pdfFile) {
  const pdfBase64 = await fileToBase64(pdfFile);
  const res = await fetch(`${API_BASE}/submissions`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...getAuthHeaders(),
    },
    body: JSON.stringify({
      scenario_id: scenarioId,
      scenario_name: scenarioName,
      pdf_filename: pdfFile.name,
      pdf_base64: pdfBase64,
    }),
  });
  return res.json();
}

export async function getSubmissionCount() {
  const res = await fetch(`${API_BASE}/submissions/count`, {
    headers: getAuthHeaders(),
  });
  return res.json();
}

export function getSession() {
  const data = sessionStorage.getItem('va_session');
  return data ? JSON.parse(data) : null;
}

export function clearSession() {
  sessionStorage.removeItem('va_token');
  sessionStorage.removeItem('va_session');
}
